import React from "react";
import LoadingIcon from "../../../components/Loading/LoadingIcon";
import { useSelector } from "react-redux";
import Copy from "../../../components/CopyComponent/Copy";

const CustomerNameText = ({ className }) => {
  const memberData = useSelector((state) => state.isMemberInfo);

  return (
    <p
      className={`text-xl text-base-light-dark dark:text-base-light-white mb-0 flex gap-[10px] items-center ${className}`}
    >
      <LoadingIcon>
        {memberData?.memId} <Copy copyLink={memberData?.memId} />
      </LoadingIcon>
    </p>
  );
};

export default CustomerNameText;
